import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../hooks";
import {
  UpdateVisitField,
  changeVisitData,
  selectVisit,
} from "../../features/visit/visitSlice";
import { Visit } from "../../interfaces/Visit";
import { useParams } from "react-router-dom";
import { getServices } from "../../apis/service";
import SymptomSelect from "./SymptomSelect";
import DiseaseSelect from "./DiseaseSelect";
import VisitFiles from "./VisitFiles";

const Diagnosis = () => {
  const visit = useAppSelector(selectVisit);
  const params = useParams();
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (params.patientId) {
      fetchDefaultServices();
    }
  }, [params]);

  const fetchDefaultServices = () => {
    getServices({ is_default_selected: true, per_page: 100 }).then(
      (res: any) => {
        const services = res.data.data.map((i: any) => {
          return {
            id: i.id,
            fee: i.fee,
            quantity: 1,
          };
        });
        updateField("services", services);
      }
    );
  };

  const updateField = (fieldName: keyof Visit, value: any) => {
    const payload: UpdateVisitField = { fieldName, value };
    dispatch(changeVisitData(payload));
  };

  const handleChangeInChiefComplaint = (complaint: string) => {
    updateField("chiefComplaint", complaint);
  };

  return (
    <div className="grid w-full gap-2 p-2 lg:gap-4 lg:p-4 lg:grid-cols-2">
      <div className="relative grid grid-cols-2 gap-2 rounded-xl border border-gray-200 bg-white py-3 shadow-sm lg:gap-4 lg:px-6 lg:py-5">
        <div className="block col-span-2">
          <span className="text-sm font-medium text-gray-700">
            Chief Complaint
          </span>
          <input
            type="text"
            id="chiefComplaint"
            name="chiefComplaint"
            value={visit.chiefComplaint}
            onChange={(e) => handleChangeInChiefComplaint(e.target.value)}
            className="mt-1 block w-full rounded-md border-0 py-1.5 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
          />
        </div>
        <div className="block col-span-2">
          <span className="text-sm font-medium text-gray-700">Symptoms</span>
          <SymptomSelect visit={visit} />
        </div>
        <div className="block">
          <span className="text-sm font-medium text-gray-700">
            Provisional Diagnosis
          </span>
          <DiseaseSelect
            propertyType="provisionalDiagnosis"
            diseaseType="disease"
            visit={visit}
          />
        </div>
        <div className="block">
          <span className="text-sm font-medium text-gray-700">
            Final Diagnosis
          </span>
          <DiseaseSelect
            propertyType="finalDiagnosis"
            diseaseType="disease"
            visit={visit}
          />
        </div>
      </div>

      <VisitFiles visit={visit} />
    </div>
  );
};

export default Diagnosis;
